require('./combobox');

module.exports = 'combobox';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/combobox/index.js
 ** module id = 78
 ** module chunks = 1
 **/